import { render, staticRenderFns } from "./OEMainDetails.vue?vue&type=template&id=7f2b4b0a&scoped=true&"
import script from "./OEMainDetails.vue?vue&type=script&lang=js&"
export * from "./OEMainDetails.vue?vue&type=script&lang=js&"
import style0 from "./OEMainDetails.vue?vue&type=style&index=0&id=7f2b4b0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2b4b0a",
  null
  
)

export default component.exports